module.exports = __webpack_public_path__ + "img/default_musician.918cdc75.png";